<template>
  <div class="e3Warp">
    <div class="inner">
      <versionNav></versionNav>
      <div style="width:100%;height:106px"></div>
      <div class="e4title">
        <img src="../assets/img/e4title_03.png" width="941" height="128">
      </div>
      <!--<div class="e4lt1">5月23日——5月29日</div>-->
      <!--<div class="e4lt2">活动范围：<strong>全区</strong></div>-->
      <div class="e4table1">
        <span>任务 1</span>每日限时任务
      </div>
      <div class="e4table2">
        <p>任务说明：玩家每天可随机接到与自身等级匹配的三个每日任务，完成任务可获得海量的合成材料。</p>
        <table class="new_table">
          <thead>
            <tr>
              <th>等级</th>
              <th>任务名称</th>
              <th>任务条件</th>
              <th>任务奖励</th>
            </tr>
          </thead>
          <tbody>
            <tr class>
              <td rowspan="40">Lv1~17</td>
              <td>[每日]水坝奇袭（普通）</td>
              <td>通关火线突袭-水坝奇袭，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]猎鲨行动（普通）</td>
              <td>通关火线突袭-猎鲨行动，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]机甲狂潮（普通）</td>
              <td>通关火线突袭-机甲狂潮，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]怒海争锋（普通）</td>
              <td>通关火线突袭-怒海争锋，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]歼星计划（普通）</td>
              <td>通关火线突袭-歼星计划，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]星海争霸（普通）</td>
              <td>通关火线突袭-星海争霸，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巴巴罗萨（普通）</td>
              <td>通关火线突袭-巴巴罗萨，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]生死时速（普通）</td>
              <td>通关火线突袭-生死时速，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪原行动（普通）</td>
              <td>通关火线突袭-雪原行动，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]丛林废墟（普通）</td>
              <td>通关枪林弹雨-丛林废墟，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巨型水坝（普通）</td>
              <td>通关枪林弹雨-巨型水坝，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]空港死斗（普通）</td>
              <td>通关枪林弹雨-空港死斗，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]加拉太塔（普通）</td>
              <td>通关枪林弹雨-加拉太塔，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪原哨站（普通）</td>
              <td>通关枪林弹雨-雪原哨站，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巴斯古堡（普通）</td>
              <td>通关枪林弹雨-巴斯古堡，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]丛林废墟（普通）</td>
              <td>通关枪林弹雨-丛林废墟，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪山基地（普通）</td>
              <td>通关枪林弹雨大作战-雪山基地，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]航天基地（普通）</td>
              <td>通关枪林弹雨大作战-航天基地，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]北欧小城（普通）</td>
              <td>通关枪林弹雨大作战-北欧小城，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]寂静诊所（普通）</td>
              <td>通关生化侵袭2.0-寂静诊所，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]绝望仓库（普通）</td>
              <td>通关生化侵袭2.0-绝望仓库，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]哀嚎病院（普通）</td>
              <td>通关生化侵袭2.0-哀嚎病院，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]月劫余生（普通）</td>
              <td>通关生化侵袭2.0-月劫余生，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]魔窟囚女（普通）</td>
              <td>通关生化侵袭2.0-魔窟囚女，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]诅咒之岛（普通）</td>
              <td>通关生化侵袭2.0-诅咒之岛，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]风雪浩劫（普通）</td>
              <td>通关生化侵袭2.0-风雪浩劫，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]死亡矿井（普通）</td>
              <td>通关生化危机大作战-死亡矿井，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]鬼域酆都（普通）</td>
              <td>通关生化危机大作战-鬼域酆都，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]女王禁地（普通）</td>
              <td>通关生化危机大作战-女王禁地，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]镜花水月（普通）</td>
              <td>通关生化危机大作战-镜花水月，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]荒城虫潮（普通）</td>
              <td>通关生化危机大作战-荒城虫潮，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]失落之城（普通）</td>
              <td>通关生化危机大作战-失落之城，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巨龙之谷（普通）</td>
              <td>通关史前战争-巨龙之谷，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]血色教堂（普通）</td>
              <td>通关最终防线-血色教堂，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]末日广场（普通）</td>
              <td>通关最终防线-末日广场，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]极地风云（普通）</td>
              <td>通关最终防线-极地风云，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]苍穹绝迹（普通）</td>
              <td>通关最终防线-苍穹绝迹，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]灭世姬战（普通）</td>
              <td>通关最终防线-灭世姬战，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]兵临城下（普通）</td>
              <td>通关最终防线-兵临城下，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]飓风突袭（普通）</td>
              <td>通关最终防线-飓风突袭，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>

            <tr class>
              <td rowspan="84">Lv18~23</td>
              <td>[每日]孤岛惊魂（简单）</td>
              <td>通关怀旧模式-孤岛惊魂，简单难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]亡魂古镇（简单）</td>
              <td>通关怀旧模式-亡魂古镇，简单难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]古墓慄影（简单）</td>
              <td>通关怀旧模式-古墓慄影，简单难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]法老亡陵（简单）</td>
              <td>通关怀旧模式-法老亡陵，简单难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]亡者监狱（普通）</td>
              <td>通关怀旧模式-亡者监狱，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]水坝奇袭（普通）</td>
              <td>通关火线突袭-水坝奇袭，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]猎鲨行动（普通）</td>
              <td>通关火线突袭-猎鲨行动，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]机甲狂潮（普通）</td>
              <td>通关火线突袭-机甲狂潮，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]怒海争锋（普通）</td>
              <td>通关火线突袭-怒海争锋，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]歼星计划（普通）</td>
              <td>通关火线突袭-歼星计划，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]星海争霸（普通）</td>
              <td>通关火线突袭-星海争霸，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巴巴罗萨（普通）</td>
              <td>通关火线突袭-巴巴罗萨，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]生死时速（普通）</td>
              <td>通关火线突袭-生死时速，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪原行动（普通）</td>
              <td>通关火线突袭-雪原行动，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]寂静诊所（普通）</td>
              <td>通关生化侵袭2.0-寂静诊所，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]绝望仓库（普通）</td>
              <td>通关生化侵袭2.0-绝望仓库，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]哀嚎病院（普通）</td>
              <td>通关生化侵袭2.0-哀嚎病院，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]月劫余生（普通）</td>
              <td>通关生化侵袭2.0-月劫余生，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]魔窟囚女（普通）</td>
              <td>通关生化侵袭2.0-魔窟囚女，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]诅咒之岛（普通）</td>
              <td>通关生化侵袭2.0-诅咒之岛，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]风雪浩劫（普通）</td>
              <td>通关生化侵袭2.0-风雪浩劫，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]死亡矿井（普通）</td>
              <td>通关生化危机大作战-死亡矿井，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]鬼域酆都（普通）</td>
              <td>通关生化危机大作战-鬼域酆都，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]女王禁地（普通）</td>
              <td>通关生化危机大作战-女王禁地，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]镜花水月（普通）</td>
              <td>通关生化危机大作战-镜花水月，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]荒城虫潮（普通）</td>
              <td>通关生化危机大作战-荒城虫潮，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]失落之城（普通）</td>
              <td>通关生化危机大作战-失落之城，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巨龙之谷（普通）</td>
              <td>通关史前战争-巨龙之谷，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]血色教堂（普通）</td>
              <td>通关最终防线-血色教堂，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]末日广场（普通）</td>
              <td>通关最终防线-末日广场，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]极地风云（普通）</td>
              <td>通关最终防线-极地风云，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]苍穹绝迹（普通）</td>
              <td>通关最终防线-苍穹绝迹，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]灭世姬战（普通）</td>
              <td>通关最终防线-灭世姬战，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]兵临城下（普通）</td>
              <td>通关最终防线-兵临城下，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]飓风突袭（普通）</td>
              <td>通关最终防线-飓风突袭，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验1500,金币5000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]水坝奇袭（困难）</td>
              <td>通关火线突袭-水坝奇袭，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]猎鲨行动（困难）</td>
              <td>通关火线突袭-猎鲨行动，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]机甲狂潮（困难）</td>
              <td>通关火线突袭-机甲狂潮，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]怒海争锋（困难）</td>
              <td>通关火线突袭-怒海争锋，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]歼星计划（困难）</td>
              <td>通关火线突袭-歼星计划，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]星海争霸（困难）</td>
              <td>通关火线突袭-星海争霸，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巴巴罗萨（困难）</td>
              <td>通关火线突袭-巴巴罗萨，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]生死时速（困难）</td>
              <td>通关火线突袭-生死时速，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪原行动（困难）</td>
              <td>通关火线突袭-雪原行动，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]丛林废墟（困难）</td>
              <td>通关枪林弹雨-丛林废墟，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巨型水坝（困难）</td>
              <td>通关枪林弹雨-巨型水坝，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]空港死斗（困难）</td>
              <td>通关枪林弹雨-空港死斗，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]加拉太塔（困难）</td>
              <td>通关枪林弹雨-加拉太塔，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪原哨站（困难）</td>
              <td>通关枪林弹雨-雪原哨站，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巴斯古堡（困难）</td>
              <td>通关枪林弹雨-巴斯古堡，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪山基地（困难）</td>
              <td>通关枪林弹雨大作战-雪山基地，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]航天基地（困难）</td>
              <td>通关枪林弹雨大作战-航天基地，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]北欧小城（困难）</td>
              <td>通关枪林弹雨大作战-北欧小城，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]寂静诊所（困难）</td>
              <td>通关生化侵袭2.0-寂静诊所，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]绝望仓库（困难）</td>
              <td>通关生化侵袭2.0-绝望仓库，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]哀嚎病院（困难）</td>
              <td>通关生化侵袭2.0-哀嚎病院，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]月劫余生（困难）</td>
              <td>通关生化侵袭2.0-月劫余生，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]魔窟囚女（困难）</td>
              <td>通关生化侵袭2.0-魔窟囚女，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]诅咒之岛（困难）</td>
              <td>通关生化侵袭2.0-诅咒之岛，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]风雪浩劫（困难）</td>
              <td>通关生化侵袭2.0-风雪浩劫，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]死亡矿井（困难）</td>
              <td>通关生化危机大作战-死亡矿井，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]鬼域酆都（困难）</td>
              <td>通关生化危机大作战-鬼域酆都，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]女王禁地（困难）</td>
              <td>通关生化危机大作战-女王禁地，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]镜花水月（困难）</td>
              <td>通关生化危机大作战-镜花水月，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]荒城虫潮（困难）</td>
              <td>通关生化危机大作战-荒城虫潮，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]失落之城（困难）</td>
              <td>通关生化危机大作战-失落之城，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巨龙之谷（困难）</td>
              <td>通关史前战争-巨龙之谷，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]血色教堂（困难）</td>
              <td>通关最终防线-血色教堂，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]末日广场（困难）</td>
              <td>通关最终防线-末日广场，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]极地风云（困难）</td>
              <td>通关最终防线-极地风云，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]苍穹绝迹（困难）</td>
              <td>通关最终防线-苍穹绝迹，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]灭世姬战（困难）</td>
              <td>通关最终防线-灭世姬战，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]兵临城下（困难）</td>
              <td>通关最终防线-兵临城下，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]飓风突袭（困难）</td>
              <td>通关最终防线-飓风突袭，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]帝国决战（困难）</td>
              <td>通关火线突袭-帝国决战，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]废港惊潮（困难）</td>
              <td>通关火线突袭-废港惊潮，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]黑石行动（困难）</td>
              <td>通关火线突袭-黑石行动，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]古寺危机（困难）</td>
              <td>通关末日求生-古寺危机，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]夺命追击（困难）</td>
              <td>通关生化危机大作战-夺命追击，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]黎明惊魂（困难）</td>
              <td>通关生化危机大作战-黎明惊魂，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪域危机（困难）</td>
              <td>通关生化危机大作战-雪域危机，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]混沌星殿（困难）</td>
              <td>通关临界防御-混沌星殿，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]极地危谷（困难）</td>
              <td>通关临界防御-极地危谷，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]密林要塞（困难）</td>
              <td>通关临界防御-密林要塞，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>

            <tr class>
              <td rowspan="91">Lv24+</td>
              <td>[每日]孤岛惊魂（简单）</td>
              <td>通关怀旧模式-孤岛惊魂，简单难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]亡魂古镇（简单）</td>
              <td>通关怀旧模式-亡魂古镇，简单难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]古墓慄影（简单）</td>
              <td>通关怀旧模式-古墓慄影，简单难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]法老亡陵（简单）</td>
              <td>通关怀旧模式-法老亡陵，简单难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]亡者监狱（普通）</td>
              <td>通关怀旧模式-亡者监狱，普通难度一次</td>
              <td>金币五倍卡x1,经验五倍卡x1,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]水坝奇袭（困难）</td>
              <td>通关火线突袭-水坝奇袭，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]猎鲨行动（困难）</td>
              <td>通关火线突袭-猎鲨行动，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]机甲狂潮（困难）</td>
              <td>通关火线突袭-机甲狂潮，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]怒海争锋（困难）</td>
              <td>通关火线突袭-怒海争锋，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]歼星计划（困难）</td>
              <td>通关火线突袭-歼星计划，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]星海争霸（困难）</td>
              <td>通关火线突袭-星海争霸，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巴巴罗萨（困难）</td>
              <td>通关火线突袭-巴巴罗萨，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]生死时速（困难）</td>
              <td>通关火线突袭-生死时速，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪原行动（困难）</td>
              <td>通关火线突袭-雪原行动，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]寂静诊所（困难）</td>
              <td>通关生化侵袭2.0-寂静诊所，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]绝望仓库（困难）</td>
              <td>通关生化侵袭2.0-绝望仓库，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]哀嚎病院（困难）</td>
              <td>通关生化侵袭2.0-哀嚎病院，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]月劫余生（困难）</td>
              <td>通关生化侵袭2.0-月劫余生，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]魔窟囚女（困难）</td>
              <td>通关生化侵袭2.0-魔窟囚女，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]诅咒之岛（困难）</td>
              <td>通关生化侵袭2.0-诅咒之岛，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]风雪浩劫（困难）</td>
              <td>通关生化侵袭2.0-风雪浩劫，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]死亡矿井（困难）</td>
              <td>通关生化危机大作战-死亡矿井，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]鬼域酆都（困难）</td>
              <td>通关生化危机大作战-鬼域酆都，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]女王禁地（困难）</td>
              <td>通关生化危机大作战-女王禁地，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]镜花水月（困难）</td>
              <td>通关生化危机大作战-镜花水月，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]荒城虫潮（困难）</td>
              <td>通关生化危机大作战-荒城虫潮，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]失落之城（困难）</td>
              <td>通关生化危机大作战-失落之城，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巨龙之谷（困难）</td>
              <td>通关史前战争-巨龙之谷，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]血色教堂（困难）</td>
              <td>通关最终防线-血色教堂，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]末日广场（困难）</td>
              <td>通关最终防线-末日广场，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]极地风云（困难）</td>
              <td>通关最终防线-极地风云，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]苍穹绝迹（困难）</td>
              <td>通关最终防线-苍穹绝迹，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]灭世姬战（困难）</td>
              <td>通关最终防线-灭世姬战，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]兵临城下（困难）</td>
              <td>通关最终防线-兵临城下，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]飓风突袭（困难）</td>
              <td>通关最终防线-飓风突袭，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]帝国决战（困难）</td>
              <td>通关火线突袭-帝国决战，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]废港惊潮（困难）</td>
              <td>通关火线突袭-废港惊潮，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]黑石行动（困难）</td>
              <td>通关火线突袭-黑石行动，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]古寺危机（困难）</td>
              <td>通关末日求生-古寺危机，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]夺命追击（困难）</td>
              <td>通关生化危机大作战-夺命追击，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]黎明惊魂（困难）</td>
              <td>通关生化危机大作战-黎明惊魂，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪域危机（困难）</td>
              <td>通关生化危机大作战-雪域危机，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]混沌星殿（困难）</td>
              <td>通关临界防御-混沌星殿，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]极地危谷（困难）</td>
              <td>通关临界防御-极地危谷，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]密林要塞（困难）</td>
              <td>通关临界防御-密林要塞，困难难度一次</td>
              <td>传承核心x1,黑铁级通用材料x80,经验3500,金币10000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]水坝奇袭（噩梦）</td>
              <td>C级及以上评价通关火线突袭-水坝奇袭，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]猎鲨行动（噩梦）</td>
              <td>C级及以上评价通关火线突袭-猎鲨行动，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]机甲狂潮（噩梦）</td>
              <td>C级及以上评价通关火线突袭-机甲狂潮，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]怒海争锋（噩梦）</td>
              <td>C级及以上评价通关火线突袭-怒海争锋，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]歼星计划（噩梦）</td>
              <td>C级及以上评价通关火线突袭-歼星计划，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]星海争霸（噩梦）</td>
              <td>C级及以上评价通关火线突袭-星海争霸，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巴巴罗萨（噩梦）</td>
              <td>C级及以上评价通关火线突袭-巴巴罗萨，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]生死时速（噩梦）</td>
              <td>C级及以上评价通关火线突袭-生死时速，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪原行动（噩梦）</td>
              <td>C级及以上评价通关火线突袭-雪原行动，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]丛林废墟（噩梦）</td>
              <td>C级及以上评价通关枪林弹雨-丛林废墟，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巨型水坝（噩梦）</td>
              <td>C级及以上评价通关枪林弹雨-巨型水坝，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]空港死斗（噩梦）</td>
              <td>C级及以上评价通关枪林弹雨-空港死斗，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]加拉太塔（噩梦）</td>
              <td>C级及以上评价通关枪林弹雨-加拉太塔，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪原哨站（噩梦）</td>
              <td>C级及以上评价通关枪林弹雨-雪原哨站，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巴斯古堡（噩梦）</td>
              <td>C级及以上评价通关枪林弹雨-巴斯古堡，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪山基地（噩梦）</td>
              <td>C级及以上评价通关枪林弹雨大作战-雪山基地，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]航天基地（噩梦）</td>
              <td>C级及以上评价通关枪林弹雨大作战-航天基地，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]北欧小城（噩梦）</td>
              <td>C级及以上评价通关枪林弹雨大作战-北欧小城，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]寂静诊所（噩梦）</td>
              <td>C级及以上评价通关生化侵袭2.0-寂静诊所，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]绝望仓库（噩梦）</td>
              <td>C级及以上评价通关生化侵袭2.0-绝望仓库，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]哀嚎病院（噩梦）</td>
              <td>C级及以上评价通关生化侵袭2.0-哀嚎病院，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]月劫余生（噩梦）</td>
              <td>C级及以上评价通关生化侵袭2.0-月劫余生，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]魔窟囚女（噩梦）</td>
              <td>C级及以上评价通关生化侵袭2.0-魔窟囚女，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]诅咒之岛（噩梦）</td>
              <td>C级及以上评价通关生化侵袭2.0-诅咒之岛，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]风雪浩劫（噩梦）</td>
              <td>C级及以上评价通关生化侵袭2.0-风雪浩劫，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]死亡矿井（噩梦）</td>
              <td>C级及以上评价通关生化危机大作战-死亡矿井，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]鬼域酆都（噩梦）</td>
              <td>C级及以上评价通关生化危机大作战-鬼域酆都，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]女王禁地（噩梦）</td>
              <td>C级及以上评价通关生化危机大作战-女王禁地，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]镜花水月（噩梦）</td>
              <td>C级及以上评价通关生化危机大作战-镜花水月，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]荒城虫潮（噩梦）</td>
              <td>C级及以上评价通关生化危机大作战-荒城虫潮，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]失落之城（噩梦）</td>
              <td>C级及以上评价通关生化危机大作战-失落之城，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]巨龙之谷（噩梦）</td>
              <td>C级及以上评价通关史前战争-巨龙之谷，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]血色教堂（噩梦）</td>
              <td>C级及以上评价通关最终防线-血色教堂，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]末日广场（噩梦）</td>
              <td>C级及以上评价通关最终防线-末日广场，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]极地风云（噩梦）</td>
              <td>C级及以上评价通关最终防线-极地风云，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]苍穹绝迹（噩梦）</td>
              <td>C级及以上评价通关最终防线-苍穹绝迹，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]灭世姬战（噩梦）</td>
              <td>C级及以上评价通关最终防线-灭世姬战，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]兵临城下（噩梦）</td>
              <td>C级及以上评价通关最终防线-兵临城下，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]飓风突袭（噩梦）</td>
              <td>C级及以上评价通关最终防线-飓风突袭，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]帝国决战（噩梦）</td>
              <td>C级及以上评价通关火线突袭-帝国决战，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]废港惊潮（噩梦）</td>
              <td>C级及以上评价通关火线突袭-废港惊潮，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]黑石行动（噩梦）</td>
              <td>C级及以上评价通关火线突袭-黑石行动，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]古寺危机（噩梦）</td>
              <td>C级及以上评价通关末日求生-古寺危机，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]夺命追击（噩梦）</td>
              <td>C级及以上评价通关生化危机大作战-夺命追击，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]黎明惊魂（噩梦）</td>
              <td>C级及以上评价通关生化危机大作战-黎明惊魂，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>
            <tr class>
              <td>[每日]雪域危机（噩梦）</td>
              <td>C级及以上评价通关生化危机大作战-雪域危机，噩梦难度一次</td>
              <td>传承核心x3,黑铁级通用材料x160,经验4500,金币15000,季券100</td>
            </tr>

            <tr class>
              <td>Lv80+</td>
              <td>[每日]突击高手（PVP）</td>
              <td>PVP任意模式，任意地图下使用突击步枪击杀20人</td>
              <td>传承核心x4,传承哀伤之霜专属材料x1,经验4500,金币15000,金币150</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="e4table3"></div>
      <div class="e4table1">
        <span>任务 2</span>每周限时任务
      </div>
      <div class="e4table2">
        <p>任务说明：玩家每天可随机接到与自身等级匹配的两个每日任务，完成任务可获得海量的合成材料。</p>
        <table class="new_table">
          <thead>
            <tr>
              <th>任务名称</th>
              <th>任务条件</th>
              <th>任务奖励</th>
            </tr>
          </thead>
          <tbody>
            <tr class>
              <td>Lv5[每周]特别训练</td>
              <td>PVE模式击杀300人</td>
              <td>黑铁通用材料x400,870MCS组件x100</td>
            </tr>
            <tr class>
              <td>Lv5[每周]巅峰对抗</td>
              <td>PVP任意模式、任意地图击杀100人</td>
              <td>黑铁通用材料x400,USP组件x100</td>
            </tr>
            <tr>
              <td>Lv10[每周]战场精英（噩梦）</td>
              <td>任意PVE地图 噩梦难度 击杀敌人人类200个</td>
              <td>白银通用材料x400,神行QBU88组件x100</td>
            </tr>
            <tr>
              <td>Lv10[每周]命运之忧</td>
              <td>PVP模式下参战时间到达180分钟</td>
              <td>白银通用材料x400,退魔MP5组件x100</td>
            </tr>
            <tr>
              <td>Lv10[每周]战意驰骋（噩梦）</td>
              <td>任意PVE地图 噩梦难度 击杀敌人生化人200个</td>
              <td>白银通用材料x400,神行QBU88组件x100</td>
            </tr>
            <tr>
              <td>Lv10[每周]致命弱点</td>
              <td>PVP任意模式，任意地图下爆头击杀45人</td>
              <td>白银通用材料x400,退魔MP5组件x100</td>
            </tr>
            <tr>
              <td>Lv20[每周]人工智能（噩梦）</td>
              <td>任意PVE地图 噩梦难度 击杀敌人机器人200个</td>
              <td>黄金通用材料x400,军灵M16A2组件x100</td>
            </tr>
            <tr>
              <td>Lv20[每周]黄金之耀</td>
              <td>PVP任意模式，任意地图下使用手枪爆头击杀30人</td>
              <td>黄金通用材料x400,毛瑟M1932组件x100</td>
            </tr>
            <tr>
              <td>Lv20[每周]生化来袭（噩梦）</td>
              <td>任意PVE地图 噩梦难度 击杀敌人生化人200个</td>
              <td>黄金通用材料x400,军灵M16A2组件x100</td>
            </tr>
            <tr>
              <td>Lv20[每周]暴风骤雨</td>
              <td>PVP任意模式，任意地图下使用突击步枪爆头击杀30人</td>
              <td>黄金通用材料x400,毛瑟M1932组件x100</td>
            </tr>
            <tr>
              <td>Lv30[每周]拔除污秽（噩梦）</td>
              <td>任意PVE地图 噩梦难度 击杀敌人鬼魂200个</td>
              <td>精钢通用材料x400,精钢M870组件x100</td>
            </tr>
            <tr>
              <td>Lv30[每周]一击狙杀</td>
              <td>PVP任意模式，任意地图下使用狙击枪爆头击杀30人</td>
              <td>精钢通用材料x400,精钢M249组件x100</td>
            </tr>
            <tr>
              <td>Lv30[每周]改造之祸（噩梦）</td>
              <td>任意PVE地图 噩梦难度 击杀敌人改造人200个</td>
              <td>精钢通用材料x400,精钢M870组件x100</td>
            </tr>
            <tr>
              <td>Lv40[每周]恐怖深渊（噩梦）</td>
              <td>PVE任意模式，任意地图，噩梦难度下获胜30场</td>
              <td>高碳通用材料x400,高碳M29组件x100</td>
            </tr>
            <tr>
              <td>Lv40[每周]Boss终结者（噩梦）</td>
              <td>任意PVE地图噩梦难度，击杀Boss 14个（最后一击）</td>
              <td>高碳通用材料x400,高碳AN94组件x100</td>
            </tr>
            <tr>
              <td>Lv50[每周]闻风丧胆（噩梦）</td>
              <td>任意PVE地图噩梦难度，击杀人类类型Boss 7个（最后一击）</td>
              <td>钛钢通用材料x400,钛钢UMP9组件x100</td>
            </tr>
            <tr>
              <td>Lv50[每周]生化末日（噩梦）</td>
              <td>任意PVE地图噩梦难度，击杀生化人类型Boss 7个（最后一击）</td>
              <td>钛钢通用材料x400,钛钢毛瑟98K组件x100</td>
            </tr>
            <tr>
              <td>Lv60[每周]机械神兵（噩梦）</td>
              <td>任意PVE地图噩梦难度，击杀机器人类型Boss 7个（最后一击）</td>
              <td>钛钢通用材料x400,钛钢UMP9组件x100</td>
            </tr>
            <tr>
              <td>Lv60[每周]驯兽之王（噩梦）</td>
              <td>任意PVE地图噩梦难度，击杀野兽类型Boss 7个（最后一击）</td>
              <td>钛钢通用材料x400,钛钢毛瑟98K组件x100</td>
            </tr>
            <tr>
              <td>Lv70[每周]魂飞魄散（噩梦）</td>
              <td>任意PVE地图噩梦难度，击杀鬼魂类型Boss 7个（最后一击）</td>
              <td>钛钢通用材料x400,钛钢UMP9组件x100</td>
            </tr>
            <tr>
              <td>Lv70[每周]摧枯拉朽（噩梦）</td>
              <td>任意PVE地图噩梦难度，击杀改造人类型Boss 7个（最后一击）</td>
              <td>钛钢通用材料x400,钛钢毛瑟98K组件x100</td>
            </tr>
            <tr>
              <td>Lv80[每周]梦魇降临（噩梦）</td>
              <td>PVE任意模式，任意地图，噩梦难度下使用手枪击杀100人</td>
              <td>传承核心x10,传承哀伤之霜专属材料x1</td>
            </tr>
            <tr>
              <td>Lv80[每周]简单粗暴（噩梦）</td>
              <td>PVE任意模式，任意地图，噩梦难度下使用突击步枪弱点击杀150人</td>
              <td>传承核心x10,传承哀伤之霜专属材料x1</td>
            </tr>
            <tr>
              <td>Lv80[每周]远程狙杀（噩梦）</td>
              <td>PVE任意模式，任意地图，噩梦难度下使用狙击枪击杀100人</td>
              <td>传承核心x10,传承哀伤之霜专属材料x1</td>
            </tr>
            <tr>
              <td>Lv90[每周]梦魇降临（噩梦）</td>
              <td>PVE任意模式，任意地图，噩梦难度下使用手枪击杀100人</td>
              <td>传承核心x10,传承哀伤之霜专属材料x1</td>
            </tr>
            <tr>
              <td>Lv90[每周]简单粗暴（噩梦）</td>
              <td>PVE任意模式，任意地图，噩梦难度下使用突击步枪弱点击杀150人</td>
              <td>传承核心x10,传承哀伤之霜专属材料x1</td>
            </tr>
            <tr>
              <td>Lv90[每周]远程狙杀（噩梦）</td>
              <td>PVE任意模式，任意地图，噩梦难度下使用狙击枪弱点击杀150人</td>
              <td>传承核心x10,传承哀伤之霜专属材料x1</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="e4table3"></div>

      <div class="e4table1">
        <span>任务 3</span>排位赛每日任务
        <small>（排位赛每日18:00点开启）</small>
      </div>
      <div class="e4table2">
        <h2>一：单兵排位赛日常</h2>
        <p>
          1、 完成一场排位赛即可获得
          <span>黄金子弹*10、金币10000、经验300的奖励。</span>
        </p>
        <h2>二：大乱斗排位赛日常</h2>
        <p>
          1、 热血乱斗：完成一场生死排位赛即可获得
          <span>黄金子弹*10、金币10000、经验300的奖励。</span>
        </p>
        <div class="clearfloat"></div>
      </div>

      <div class="e4table3"></div>

      <div class="e4table1">
        <span>任务 4</span>
        匹配每日日常
      </div>
      <div class="e4table2">
        <p>1、在PVP中，使用匹配系统完成三次任意地图的比赛，即可获得白银子弹*10、经验300、金币5000、季券10</p>
        <p>
          2、在PVP中，使用匹配系统在任意地图中击杀10名敌人，即可获得白银子弹*20、经验300、金币*5000、季券10
          <span></span>
        </p>
        <p>3、在PVP中，使用匹配系统在任意地图中累积获得胜利3次，即可获得黄金子弹*10、经验300、金币*5000、季券20</p>
        <p>4、在PVP中，使用匹配系统在任意地图中击杀20名敌人，即可获得新生装置（1天）、经验300、金币*5000、季券20</p>
      </div>
      <div class="e4table3"></div>
      <div class="h50"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "e3"
}
</script>

<style scoped>
@import "./pagesCss/e3.css"
</style>



// WEBPACK FOOTER //
// src/pages/e3.vue